import { UserIdSchema } from "@core/domains/identity";
import { StageSchema } from "@core/foundation/stage";
import { z } from "@core/zod";

export const OAuthClaimsSchema = z.object(
  {
    aud: z.url(),
    clientId: z.string(),
    exp: z.number(),
    iat: z.number(),
    id: UserIdSchema,
    scope: z.string().optional(),
    stage: StageSchema,
    type: z.literal("oauth"),
    version: z.literal(1),
  },
  {
    aud: "The URL of the resource the token is bound to.",
    clientId: "The id of the OAuth client the token was issued to.",
    exp: "When the token expires, in seconds since the Unix epoch.",
    iat: "When the token was issued, in seconds since the Unix epoch.",
    id: "The id of the user who granted the client access.",
    scope: "The granted scopes, separated by spaces.",
    stage: "The stage the token was issued in.",
    type: "The token's kind, always oauth.",
    version: "The version of the claims' shape.",
  },
);

export interface OAuthClaims extends z.infer<typeof OAuthClaimsSchema> {}
